import { Icon } from "./Icon";

/**
 * A bento card with an icon, label, heading and text. Pass `aside` to group the
 * copy and show the aside next to it; pass `children` to append under the copy.
 */
export function FeatureCard({ variant, icon, label, title, text, delay, aside, children }) {
  const copy = (
    <>
      <p className="feature-label">{label}</p>
      <h3>{title}</h3>
      <p>{text}</p>
    </>
  );

  return (
    <article className={`feature-card ${variant}`} data-reveal style={delay ? { "--delay": delay } : undefined}>
      <span className="feature-icon">
        <Icon name={icon} />
      </span>
      {aside ? <div>{copy}</div> : copy}
      {aside}
      {children}
    </article>
  );
}
